import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetApplicationInformation = createAsyncThunk(
  "ApplicationInformation/GetApplicationInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/GetOneSU_NT_MRI_ApplicationInformation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"app");
      return data; // Return the extracted data
      
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddApplication = createAsyncThunk(
  "AddApplicationInfo/AddApplication",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AddApplicationInfo/AddApplication",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SubmitApplication = createAsyncThunk(
  "AddApplicationInfo/SubmitApplication",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/SubmitApplication",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AgreeTerms = createAsyncThunk(
  "SU_NT_MRI_ApplicationInformationModel/AgreeTerms",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/AgreeTerms",
        parameters
      );
 
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const ChangeApplicationStatus = createAsyncThunk(
  "SU_NT_MRI_ApplicationInformationModel/ChangeApplicationStatus",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/ChangeApplicationStatus",
        parameters
      );
 
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const ApplicationInformationReducers = createSlice({
  name: "ApplicationInformation",
  initialState: {
    ApplicationInformation: {},
    loadingApplicationInformation: false,
    errorApplicationInformation: null,
    //------------- AddApplication ---------------------
    AddApplication: "",
    loadingAddApplication: false,
    errorAddApplication: null,


    SubmitApplication: {},
    loadingSubmitApplication: false,
    errorSubmitApplication: null,

    //------------- AgreeTerms ---------------------
    AgreeTerms: {},
    loadingAgreeTerms: false,
    errorAgreeTerms: null,

    //------------- ChangeApplicationStatus ---------------------
    ChangeApplicationStatus: {},
    loadingChangeApplicationStatus: false,
    errorChangeApplicationStatus: null,

  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetApplicationInformation.pending, (state, action) => {
        console.log(action.payload, "action.payload");
        
        state.loadingApplicationInformation = true;
        state.ApplicationInformation = action.payload;
        state.errorApplicationInformation = null;
      })
      .addCase(GetApplicationInformation.fulfilled, (state, action) => {
        state.loadingApplicationInformation = false;
        state.ApplicationInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetApplicationInformation.rejected, (state, action) => {
        state.loadingApplicationInformation = false;
        state.ApplicationInformation = action.payload;
      })
      //------------------- AddApplication -----------------------------------
      builder
        .addCase(AddApplication.pending, (state, action) => {
          state.loadingAddApplication = true;
          state.AddApplication = action.payload;
          state.errorAddApplication = null;
        })
        .addCase(AddApplication.fulfilled, (state, action) => {
          state.loadingAddApplication = false;
          state.AddApplication = action.payload; // Assuming payload has the desired data
        })
        .addCase(AddApplication.rejected, (state, action) => {
          state.loadingAddApplication = false;
          state.errorAddApplication = action.payload;
        });


        builder
        .addCase(SubmitApplication.pending, (state, action) => {
          state.loadingSubmitApplication = true;
          state.SubmitApplication = action.payload;
          state.loadingSubmitApplication = null;
        })
        .addCase(SubmitApplication.fulfilled, (state, action) => {
          state.loadingSubmitApplication = false;
          state.SubmitApplication = action.payload; // Assuming payload has the desired data
        })
        .addCase(SubmitApplication.rejected, (state, action) => {
          state.loadingSubmitApplication = false;
          state.loadingSubmitApplication = action.payload;
        });

         //------------------- AgreeTerms -----------------------------------
      builder
      .addCase(AgreeTerms.pending, (state, action) => {
        state.loadingAgreeTerms = true;
        state.AgreeTerms = action.payload;
        state.errorAgreeTerms = null;
      })
      .addCase(AgreeTerms.fulfilled, (state, action) => {
        state.loadingAgreeTerms = false;
        state.AgreeTerms = action.payload; // Assuming payload has the desired data
      })
      .addCase(AgreeTerms.rejected, (state, action) => {
        state.loadingAgreeTerms = false;
        state.errorAgreeTerms = action.payload;
      });
 //------------------- AgreeTerms -----------------------------------
      builder
      .addCase(ChangeApplicationStatus.pending, (state, action) => {
        state.loadingChangeApplicationStatus = true;
        state.ChangeApplicationStatus = action.payload;
        state.errorAgreeTerms = null;
      })
      .addCase(ChangeApplicationStatus.fulfilled, (state, action) => {
        state.loadingChangeApplicationStatus = false;
        state.ChangeApplicationStatus = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeApplicationStatus.rejected, (state, action) => {
        state.loadingChangeApplicationStatus = false;
        state.errorChangeApplicationStatus = action.payload;
      });
  },
});

export default ApplicationInformationReducers.reducer;
